
import {BehaviorSubject,Observable,from } from 'rxjs';
import {map} from 'rxjs/operators';

import { RoleUserRelationServiceProxy ,UserDto,IdListInDto} from '@/service-proxies/app-v2/user.service-proxies';

function userDtoToRoleUserInfo(user:UserDto):RoleUserInfo{
  const result:any={
    ...user
  };
  const userInfo=result as RoleUserInfo;
  userInfo.alias = user.realName;
  return userInfo;
}

export class RoleUserInfo{
  id?:string;
  name?:string;
  alias?:string;
  avatar?:string;
}

export class RoleUserStoreService{

  private readonly roleUserService:RoleUserRelationServiceProxy;

  constructor(){
    this.roleUserService = new RoleUserRelationServiceProxy();
  }

  findRolerUserList(roleId:string):Observable<RoleUserInfo[]>{
    return from(this.roleUserService.userList(roleId))
      .pipe(
        map(c=>(c.data) || []),
        map(c=>c.map(d=>userDtoToRoleUserInfo(d)))
      )
  }

  saveRoleUser(roleId:string, userIdList:string[]){
    const idList:IdListInDto = new IdListInDto();
    idList.ids = userIdList;
    return from(this.roleUserService.roleBindUsers(idList,roleId));
  }

  removeRoleUser(roleId:string,userId:string){
    const idList:IdListInDto = new IdListInDto();
    idList.ids = [userId];
    return from(this.roleUserService.removeUserList(idList,roleId));
  }

}

const roleUserStoreService:RoleUserStoreService = new RoleUserStoreService();
export default roleUserStoreService;
